import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-management/lang';
import QrCodeImg from '@blade/common/components/qr-code/index.vue';
// import { EPassCodeStatus } from '@blade-sxp/portrait-management/interfaces/portrait';
import html2canvas from 'html2canvas';
let default_1 = class default_1 extends Vue {
    detail;
    tyepsConfig = {
        DYNAMIC: this.$t('dynamic'),
        STATIC: this.$t('static'),
    };
    get computedTxt() {
        return this.detail?.content ?? '';
    }
    get computedDate() {
        return `${this.detail?.validateStartDate} ~ ${this.detail?.validateEndDate}`;
    }
    get computedName() {
        return this.detail?.portraitName ?? '';
    }
    get computedCount() {
        const { totalCount, usedCount } = this.detail ?? {};
        const count = `${usedCount}/${totalCount}`;
        return totalCount === -1 ? this.$t('unlimitedTimes') : count;
    }
    get computedType() {
        return this.tyepsConfig?.[this.detail?.type] ?? '';
    }
    handleRegerate() {
        this.$emit('handleRegerate');
    }
    handleEdit() {
        this.$emit('handleEdit');
    }
    downloadQrCode() {
        // (this.$refs?.qrCodeImgRef as any)?.download();
        const dom = this.$refs?.viewPassCodeContentRef;
        if (dom) {
            html2canvas(dom).then((canvas) => {
                const href = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = href;
                link.download = `${new Date().getTime()}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "detail", void 0);
default_1 = __decorate([
    Component({
        name: 'viewPassCode',
        components: { QrCodeImg },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
